<template>
	<CRow>
		<CCol col="12">
			<CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>{{ $lang.ai_scholarship_plan.title }}</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
								<CButton color="primary" v-on:click="createTableRow" style="margin-right: 10px;" v-if="checkPermission('create-ai-scholarship-plan')">
									{{ $lang.buttons.general.crud.create }}
								</CButton>
							</div>
						</CCol>
					</div>
				</CCardHeader>
				<CCardBody>
                    <v-server-table :url="module.api.list" :columns="columns" :options="options" :data="data" ref="myTable">
                        <template #createdAt="data">
                            {{ dateTimeUTCtoLocalFormat(data.row.createdAt) }}
                        </template>

                        <!-- ✅ Platform: show "Web, Android, IOS" for free plans, DB value for paid -->
                        <template #platform="data">
                            <span v-if="data.row.isFree">Web, Android, IOS</span>
                            <span v-else>{{ data.row.platform || '-' }}</span>
                        </template>

						<!-- ✅ isFree badge -->
                        <template #isFree="data">
                            <CBadge :color="data.row.isFree ? 'success' : 'secondary'">
                                {{ data.row.isFree ? 'Free' : 'Paid' }}
                            </CBadge>
                        </template>

						<template #actions="data">
							<CButton color="success" v-c-tooltip="$lang.buttons.general.crud.edit" v-on:click="editTableRow(data.row.id)" v-if="checkPermission('edit-ai-scholarship-plan')">
								<i class="fas fa-pencil-alt"></i>
							</CButton>
							<CButton color="warning" v-c-tooltip="$lang.buttons.general.crud.view"
								v-on:click="viewTableRow(data.row.id)" v-if="checkPermission('view-ai-scholarship-plan')">
								<i class="fas fa-eye"></i>
							</CButton>
                            <CButton color="danger" v-c-tooltip="$lang.buttons.general.crud.delete" v-on:click="deletePopup(data.row.id)" v-if="checkPermission('delete-ai-scholarship-plan')">
								<i class="fas fa-trash"></i>
							</CButton>
						</template>
          			</v-server-table>
        		</CCardBody>
      		</CCard>
    	</CCol>
  	</CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { aiScholarshipPlan } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from 'vue-tables-2';
import VueJsonToCsv from "vue-json-to-csv";
import VueSweetalert2 from 'vue-sweetalert2';
import Avatar from "/src/components/Avatar";
import store from "../../store/store";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false)
Vue.use(VueForm, options);
export default {
	name: 'AiScholarshipPlan',
	mixins: [Mixin],
	components: {
		VueJsonToCsv,
		Avatar
	},
	data() {
		return {
			dismissCountDown: 0,
			alertMessage: '',
			messageColor: 'success',
			self: this,
			json_data: [],
			json_label: {},
			json_title: "",
			// ✅ isFree column added
			columns: ['title', 'platform', 'userType', 'skuCodeAndroid', 'skuCodeIos', 'credits', 'offerCredits', 'isFree', 'createdAt', 'actions'],
			data: [],
            module: aiScholarshipPlan,
			options: {
				headings: {
					title:          this.$lang.ai_scholarship_plan.table.title,
					platform:       this.$lang.ai_scholarship_plan.table.platform,
					userType:       this.$lang.ai_scholarship_plan.table.userType,
					skuCodeAndroid: this.$lang.ai_scholarship_plan.table.skuCodeAndroid,
					skuCodeIos:     this.$lang.ai_scholarship_plan.table.skuCodeIos,
					credits:        this.$lang.ai_scholarship_plan.table.credits,
					offerCredits:   this.$lang.ai_scholarship_plan.table.offerCredits,
					isFree:         'Plan Type',   // ✅
					createdAt:      this.$lang.ai_scholarship_plan.table.createdAt,
					actions:        this.$lang.common.general.actions,
				},
				editableColumns: ['title'],
				sortable: [],
				filterable: ['title']
			}
		}
	},
	created() {
		let self = this;
		if (localStorage.getItem('notificationMessage') !== "") {
			self.dismissCountDown = 10;
			self.alertMessage = localStorage.getItem('notificationMessage');
			self.messageColor = localStorage.getItem('notificationType');
			localStorage.setItem('notificationMessage', '');
			localStorage.setItem('notificationType', '');
		}
	},
    mounted() {
        let self = this;
		store.commit('showLoader', false);
		self.dismissCountDown = 0;
		self.dismissCountDownS = 0;
	},
	methods: {
		editTableRow(item) {
			this.$router.push({ name: 'AI Scholarship Edit Plan', params: { id: item } })
		},
		viewTableRow(item) {
			this.$router.push({ name: 'AI Scholarship View Plan', params: { id: item } })
		},
		createTableRow() {
			this.$router.push({ name: 'AI Scholarship Create Plan'})
		},
		deletePopup(item) {
			this.$swal({
				title: this.$lang.common.delete_swal.are_you,
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#e55353",
				confirmButtonText: this.$lang.common.delete_swal.yes_delete,
				cancelButtonText: this.$lang.common.delete_swal.cancel
			}).then((result) => {
				if (result.value) {
					let self = this;
					axios.delete(this.deleteUrlApi(this.module, item), self).then(function(response) {
                        if (response.status === 200) {
                            self.$refs.myTable.refresh();
                            self.alertMessage = response.data.message;
                            self.dismissCountDown = 10;
                            self.messageColor = "success";
                        } else {
                            self.$refs.myTable.refresh();
                            self.alertMessage = response.data.message;
                            self.messageColor = "danger";
                            self.dismissCountDownS = 10;
                        }
                    }).catch(function(error) {
                        let data;
                        if (error.response.data.error) {
                            data = error.response.data.error.toString();
                        } else {
                            data = error.response.data.message;
                        }
                        self.alertMessage = data;
                        self.messageColor = "danger";
                        self.dismissCountDownS = 10;
                    });
				}
			});
		},
	}
}
</script>